import { CYCLES } from "@/constants/cycle";

export const getSidebarNav = (isAdministrator, entityId, quarter_obj) => {
  const closingFileRoute = "/closing-file";
  const adminRoutes = isAdministrator
    ? [
        {
          name: "Members",
          to: "/members",
          icon: "fa fa-user",
        },
        {
          name: "Entity Id Form",
          to: "/entity-id-form",
          icon: "fa fa-wpforms",
        }
      ]
    : [];

  const closingFile = [
    {
      name: "Closing file",
      to: closingFileRoute,
      icon: "fa fa-archive",
      asLink: true,
      items: quarter_obj ? [
        {
          name: quarter_obj?.display_name,
          asLink: true,
          to: `${closingFileRoute}/${quarter_obj.name}`,
          items: entityId ? [
            {
              name: entityId,
              asLink: true,
              to: `${closingFileRoute}/${quarter_obj.name}/${entityId}`,
              items: Object.entries(CYCLES).map(([value, name]) => ({name, to: `${closingFileRoute}/${quarter_obj.name}/${entityId}/${value}`}))
            }
          ] : []
        }
      ] : []
    },
  ];
  return [
    {
      name: "List of tasks",
      to: "/list-of-tasks",
      icon: "fa fa-list",
    },
    ...adminRoutes,
    {
      name: "Entity List",
      to: "/entity-list",
      icon: "fa fa-building",
    },
    {
      name: "Label Management",
      to: "/label-management",
      icon: "fa fa-tag",
    },
    ...closingFile,
  ];
};
